import { render, staticRenderFns } from "./CatalogCurrentReward.vue?vue&type=template&id=8c735bfa&"
import script from "./CatalogCurrentReward.vue?vue&type=script&lang=ts&"
export * from "./CatalogCurrentReward.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports